<section class="qvs-login-legal">
  <hr class="qvs-login-legal__divider" />
  <h1 class="qvs-login-legal__title">{{ title | translate }}</h1>
  <div class="qvs-login-legal__content-wrapper">
    <article class="qvs-login-legal__content" [innerHTML]="articleText | translate"></article>
  </div>
</section>
